<template>
  <div class='app-main'>
    <div class="show-header">
      <app-header :class="'app-header'" v-show="!getFullscreenStatus"/>
    </div>
    <div :class="{'show-main':!getFullscreenStatus,'show-main-fullscreen':getFullscreenStatus}">
      <transition name='fade'>
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import appHeader from '../components/common/appHeader';

export default {
  name: 'app-main',
  data() {
    return {
      clientHeight: document.documentElement.clientHeight,
    };
  },
  components: {
    appHeader,
  },
  computed: {
    // 获取全屏状态，决定是否隐藏头栏
    getFullscreenStatus() {
      return this.$store.getters.getFullscreenStatus;
    },
    // 获取OTA结果，用于有OTA推送时通知
    getOTAResultArr() {
      return this.$store.getters.getOTAResultArr;
    },
    // 有设备掉线时通知
    getOffLineDeviceId() {
      return this.$store.getters.getOffLineDeviceId;
    },
    // 有设备上线时通知
    getOnLineDeviceId() {
      return this.$store.getters.getOnLineDeviceId;
    },
    /**
             * 被计算的高度
             * @return {number}
             */
    H() {
      return document.documentElement.clientHeight - 60;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm.
    });
  },
  mounted() {
    const self = this;
    this.$store.dispatch('websocketConnect');
    // window.onresize = function () {
    //   self.H = document.documentElement.clientHeight - 60;
    // }
  },
  beforeDestroy() {
    // 在页面销毁的时候断开websockets的连接
    this.$store.dispatch('websocketClose');
  },
  methods: {
    ...mapActions('Device', ['getDeviceList']),
  },
  watch: {
    getOTAResultArr() {
      if (this.getOTAResultArr.length > 0) {
        const deviceName = this.getOTAResultArr[0];
        const canIndex = this.getOTAResultArr[1];
        const ok = this.getOTAResultArr[2];
        if (ok === true) {
          this.$notify({
            title: '成功',
            message: `${deviceName}的CAN${canIndex}顺利完成刷写`,
            type: 'success',
          });
        } else {
          this.$notify({
            title: '失败',
            message: `${deviceName}的CAN${canIndex}不幸刷写失败`,
            type: 'error',
          });
        }
      }
    },
    getOffLineDeviceId() {
      if (this.getOffLineDeviceId.length > 0) {
        this.$notify({
          title: '下线提醒',
          message: `ID为${this.getOffLineDeviceId}的设备已下线`,
          type: 'warning',
        });
        this.getDeviceList();
      }
    },
    getOnLineDeviceId() {
      if (this.getOnLineDeviceId.length > 0) {
        this.$notify({
          title: '上线提醒',
          message: `ID为${this.getOffLineDeviceId}的设备成功上线`,
          type: 'success',
        });
      }
      this.getDeviceList();
    },
  },
};
</script>

<style lang="scss" scoped>
  .app-main {
    width: 100%;
    height: 100%;
    position: relative;

    .show-header {
      height: 60px;
      flex-shrink: 0;
      flex-grow: 0;
    }

    .show-main {
      position: absolute;
      top: 60px;
      right: 0;
      left: 0;
      bottom: 0;
    }
    .show-main-fullscreen {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/appMain.vue